import React from "react";

import {OptionalContent} from "../../../components/OptionalContent";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import List from "@mui/material/List";
import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import {DateFormatter} from "../../../services/date";
import EditIcon from "@mui/icons-material/Edit";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import FormBookingItem from "./FormBookingItem";


const BookingItemList = ({booking, accommodations}) => {
    const bookingItems = booking?.bookingItems ?? [];
    const [bookingItemOnEdit, setBookingItemOnEdit] = React.useState(null);

    const canAddAccommodationUnit = accommodations.accommodationUnits.length > bookingItems.length;

    return <Card sx={{mt: 3}}>
        <CardHeader title="Strutture prenotate"
                    titleTypographyProps={{color: "primary.main", variant: 'button'}}
                    sx={{pb: 0}}
                    action={
                        canAddAccommodationUnit &&
                        <Button onClick={() => setBookingItemOnEdit({})}
                                size="small"
                                disabled={!booking.isEditable()}
                                endIcon={<AddIcon fontSize="small"/>}>
                            Aggiungi
                        </Button>
                    }/>
        <OptionalContent hasContent={bookingItems.length > 0} showIcon noContentMessage={"Nessuna struttura presente"}>
            <List>
                {
                    bookingItems.map(bookingItem => {
                        const {bookableId, arrival, departure, price} = bookingItem;
                        const apartment = accommodations.findApartment(bookableId);
                        return <ListItem key={bookingItem.id}>
                            <ListItemAvatar>
                                <Avatar variant='rounded' src={apartment?.icon} alt={apartment?.name}>
                                    {apartment?.name ? apartment?.name.charAt(0) : "A"}
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={`${apartment?.accommodation?.name} - ${apartment?.name}`}
                                          secondary={`${DateFormatter.shortString(arrival)} - ${DateFormatter.shortString(departure)}`}/>
                            {
                                <Typography fontWeight="medium" textAlign="right" paddingRight={1} whiteSpace="nowrap">
                                    {`${price ? price : '--.--'} €`}
                                </Typography>
                            }
                            {
                                <IconButton aria-label="modifica struttura" size="small"
                                            onClick={() => setBookingItemOnEdit(bookingItem)}>
                                    <EditIcon fontSize="small"/>
                                </IconButton>
                            }
                        </ListItem>
                    })
                }
            </List>
        </OptionalContent>
        {
            bookingItemOnEdit && <FormBookingItem booking={booking}
                                                  bookingItem={bookingItemOnEdit}
                                                  accommodations={accommodations}
                                                  onClose={() => setBookingItemOnEdit(null)}/>
        }
    </Card>
}

export default BookingItemList;